import React, { useEffect, useRef, useState } from 'react'
import { IoCaretBackOutline } from 'react-icons/io5'
import { CommonHeadFooter, NewsLetterStyle } from '../../../StyledComponents'
import { Col, Row, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FaAngleDown } from "react-icons/fa6";
import { Download, Loader } from 'react-feather';
import ManageTable from '../../Manage/ManageTable';
import PopupModal from '../../Manage/PopupModal';
import { CSVLink } from 'react-csv';
import toast from 'react-hot-toast';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import styles from './index.module.scss'

const TransactionHistory = (props) => {

    const { data, showState, onCancel } = props;

    const [name, setName] = useState('Transaction History')

    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    const tableRef = useRef();

    const transctionHistoryData = [
        { label: 'Gift Card Number:', value: '1234-5678-9101' },
        { label: 'Current Balance:', value: '$50' },
        { label: 'Gift Card Type:', value: 'E-Gift Card' },
        { label: 'Expiration date:', value: '01/01/2025' },
    ]

    const transactionData = [
        {
            date: "01/10/2024",
            description: "Purchase at Store ABC",
            spent: "$20",
            added: "-",
            balance: "$50",
            type: "Purchase",
        },
        {
            date: "01/10/2024",
            description: "Reload via Credit Card ending 1234",
            spent: "-",
            added: "$10",
            balance: "$70",
            type: "Reload",
        },
        {
            date: "01/10/2024",
            description: "Purchase at Store ABC",
            spent: "$10",
            added: "-",
            balance: "$60",
            type: "Purchase",
        },
        {
            date: "01/10/2024",
            description: "Purchase at Store ABC",
            spent: "$5",
            added: "-",
            balance: "$70",
            type: "Purchase",
        }
    ];

    useEffect(() => {
        // Simulate fetching data
        setTableData(transactionData);
        setLoading(false);
    }, []);

    const [openName, setOpenName] = useState('');
    const [viewDetails, setViewDetails] = useState([])

    const clickHandler = (data) => {
        setModal(true);
        setOpenName('Transaction Details');
        setViewDetails(data)
    };

    const columns = [
        {
            name: "Date",
            cell: (row) => <span title={row.date} className="ellipsis">{row.date}</span>,
            selector: (row) => row.date,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Description",
            cell: (row) => <span title={row.description} className="ellipsis">{row.description}</span>,
            selector: (row) => row.description,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Spent",
            cell: (row) => <span title={row.spent} className="ellipsis">{row.spent}</span>,
            selector: (row) => row.spent,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Added",
            cell: (row) => <span title={row.added} className="ellipsis">{row.added}</span>,
            selector: (row) => row.added,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Balance",
            cell: (row) => <span title={row.balance} className="ellipsis">{row.balance}</span>,
            selector: (row) => row.balance,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Type",
            cell: (row) => <span title={row.type} className="ellipsis">{row.type}</span>,
            selector: (row) => row.type,
            sortable: true,
            minWidth: "auto",
        },
        {
            name: "Action",
            cell: (row) => (
                <span title={'View Detail'} className="ellipsis">
                    <div style={{ cursor: 'pointer' }} onClick={() => clickHandler(row)}>View Detail</div>
                </span>
            ),
            selector: (row) => 'View Detail',
            sortable: true,
            minWidth: "auto",
        },
    ];

    const handleDownload = () => {
        if (tableData.length === 0) {
            toast.error('There is no data to download');
        }
    };

    const handleDownloadPDF = () => {
        if (tableData.length === 0) {
            toast.error('There is no data to download');
            return;
        }

        const doc = new jsPDF();

        // Adding title to the PDF
        doc.text('Transaction History', 10, 10);

        // Filter out the "Action" column
        const filteredColumns = columns.filter(col => col.name !== "Action");

        // Define headers and rows using the filtered columns and tableData
        const headers = filteredColumns.map(col => col.name);
        const rows = tableData.map(row =>
            filteredColumns.map(col => typeof col.selector === 'function' ? col.selector(row) : '')
        );

        // Adding table to the PDF with autoTable
        autoTable(doc, {
            startY: 20,
            head: [headers],
            body: rows,
        });

        // Download the PDF
        doc.save(`${name}.pdf`);
    };




    return (
        <>
            <Row className='p-md-2 px-md-4'>
                <Col xl='1' lg='1' md='1' sm='12' xs='12'>
                    <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                </Col>
                <Col xl='11' lg='11' md='11' sm='12' xs='12' >
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                        <div className='text-center fw-bold fs-4 flex-grow-1'>Transaction History</div>
                        <div className='d-flex'>
                            <button type='button' className='btn' style={{ backgroundColor: '#1A2425', color: 'white' }}>print</button>
                            &ensp;
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle caret color='primary' style={{ backgroundColor: '#1A2425', color: 'white' }}>
                                    Export as
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={handleDownloadPDF}>PDF</DropdownItem>

                                    <CSVLink
                                        data={tableData}
                                        // filename="your_data.csv"
                                        filename={`${name}.csv`}
                                        // className="btn btn-primary"
                                        target="_blank"
                                        onClick={handleDownload}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <DropdownItem>CSV</DropdownItem>
                                    </CSVLink>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>

                    {/* <Row>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Row style={{ marginBottom: '0.2rem', padding: '5px' }}>
                                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                    <CommonHeadFooter style={{ fontWeight: '700' }}>Gift Card Details</CommonHeadFooter>
                                </Col> <br /><br />
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'><CommonHeadFooter> Gift Card Number:</CommonHeadFooter></Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.giftCardNo}</Col>
                            </Row>
                            <Row style={{ marginBottom: '0.2rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'><CommonHeadFooter>Current Balance:</CommonHeadFooter></Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.amount}</Col>
                            </Row>
                            <Row style={{ marginBottom: '0.2rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'><CommonHeadFooter>Gift Card Type:</CommonHeadFooter> </Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.type}</Col>
                            </Row>
                            <Row style={{ marginBottom: '0.2rem', padding: '5px' }}>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'><CommonHeadFooter>Expiration date:</CommonHeadFooter> </Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.validityPeriod}</Col>
                            </Row>
                        </Col>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <br />
                        </Col>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <NewsLetterStyle>Transaction history:</NewsLetterStyle>
                            {loading ? <Loader /> :
                                <ManageTable
                                    name={'Transaction History'}
                                    columns={columns}
                                    setTableData={setTableData}
                                    tableData={tableData}
                                />
                            }
                        </Col>
                    </Row> */}
                </Col>
                <PopupModal
                    open={modal}
                    setModal={setModal}
                    handleModal={handleModal}
                    name={openName}
                    tableData={viewDetails}
                    setTableData={setViewDetails}
                />
            </Row>

            <div>
                <div className='fw-bold fs-5 mb-2'>Gift Card Details</div>
                <div className={styles['wrapper']}>
                    {transctionHistoryData.map(item => (
                        <>
                            <div className='fw-medium'>{item.label}</div>
                            <div>{item.value}</div>
                        </>
                        // <Row noGutters>
                        //     <Col xs='2'>{item.label}</Col>
                        //     <Col>{item.value}</Col>
                        // </Row>
                    ))}
                </div>

                <div className='mt-md-4 mt-2'>
                    <div className='fw-medium fs-5'>Transaction history:</div>
                    {loading ? <Loader /> :
                        <ManageTable
                            name={'Transaction History'}
                            columns={columns}
                            setTableData={setTableData}
                            tableData={tableData}
                        />
                    }
                </div>
            </div>

        </>
    )
}

export default TransactionHistory
